import React, { FC, HTMLAttributes } from 'react';
import classNames from '../../helpers/classNames';
import FormattedCurrency from '../FormattedCurrency/FormattedCurrency';
import styles from './AccommodationItem.module.scss';
import useTranslate from '../../hooks/useTranslate';

interface AccommodationItemTotalProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  value: number;
  currencyName: string;
}

export const AccommodationItemTotal: FC<AccommodationItemTotalProps> = props => {
  const { value, currencyName, className } = props;
  const { translate } = useTranslate();

  return (
    <div className={classNames(className, styles.itemBody)}>
      <div className={styles.title}>{String(translate('accommodation.total'))}</div>
      <div className="flex-shrink-0">
        <FormattedCurrency value={value} name={currencyName} className={styles.price} />
      </div>
    </div>
  );
};
